<template>
  <transition name="fade">
    <div v-show="show">
      <div class="loading-mask" v-if="hasMask"></div>
      <div class="loading-main" :class="{ 'loading-main-text': msg }">
        <div class="loading-icon">
          <img src="./assets/loading.png" alt="loading" />
        </div>
        <p class="loading-content" v-if="msg">{{ msg }}</p>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "Loading",
  data() {
    return {
      show: false,
      msg: "",
      hasMask: true
    };
  }
};
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: 0.3s ease-out;
}
.fade-enter {
  opacity: 0;
  // transform: scale(1.2);
}
.fade-leave-active {
  opacity: 0;
  // transform: scale(0.8);
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99999;
}
.loading-main {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(8, 8, 8, 0.5);
  width: 150px;
  min-height: 150px;
  z-index: 99999;
  border-radius: 10px;
}
.loading-icon {
  img {
    display: block;
    width: 80px;
    height: 80px;
    margin: 35px auto 0;
    animation: rotate 1s linear infinite;
  }
}
.loading-content {
  margin-top: 10px;
  font-size: 28px;
  color: #fff;
  width: 100%;
  overflow: hidden;
  text-align: center;
}
.loading-main-text {
  width: 200px;
  min-height: 200px;
  .loading-icon {
    img {
      display: block;
      width: 80px;
      height: 80px;
      margin: 40px auto 0;
      animation: rotate 1s linear infinite;
    }
  }
  .loading-content {
    margin-top: 25px;
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
